<template>
  <popover-form-wrapper :note="note" :store-url="storeUrl" @stored="onStored"
                        :can-set-read-only-note="canSetReadOnlyNote">
    <div class="wrapper">
      <div class="wrapper" v-for="item in readOnlyNotes">
        <el-tooltip content="Special note visible to all users" placement="top" effect="light">
          <i class="fas fa-info-circle"></i>
        </el-tooltip>
        {{ item.model.note }}
      </div>
      <multi-line-view :value="content" :maxHeight="75"></multi-line-view>
    </div>
  </popover-form-wrapper>
</template>

<script>
import MultiLineView from '../../components/note/multi-line-view';
import PopoverFormWrapper from '../../components/note/popover-form-wrapper';
import eventBus from "../../event-bus";

export default {
  components: {
    PopoverFormWrapper,
    MultiLineView,
  },

  props: {
    note: Object,
    storeNoteUrl: String,
    readOnlyNotes: Array,
    canSetReadOnlyNote: Boolean,
  },

  computed: {
    /**
     * @return {Object}
     */
    content() {
      return _.get(this.note, 'model.note', null);
    },

    /**
     * @return {string}
     */
    storeUrl() {
      return _.get(this.note, 'updateUrl', this.storeNoteUrl);
    },
  },

  methods: {
    /**
     * @param {object|null} model
     */
    onStored({model}) {
      const payload = {brandId: null, contactId: null, model: null};
      if (model) {
        payload.brandId = _.get(model, 'model.brand_id');
        payload.contactId = _.get(model, 'model.contact_id');
        payload.model = model;
      } else if (this.note) {
        payload.brandId = _.get(this.note, 'model.brand_id');
        payload.contactId = _.get(this.note, 'model.contact_id');
      }

      eventBus.$emit('contact-note-stored', payload);
    },
  },
}
</script>
